module.exports = __webpack_public_path__ + "static/2-Kas-tai-86b0aaada61d0e10f6df6d58a19ed1c5.svg";